import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   Typography,
//   Card,
//   CardContent,
//   Container,
//   Button,
// } from "@mui/material";
import * as services from "./../../services/customer";
import img from "../../images/profile_example.jpg";
import { useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import AddIcon from "@mui/icons-material/Add";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import SearchIcon from "@mui/icons-material/Search";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

export default function CustomerListPage() {
  const [search, setSearch] = useState("");
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCustomer();
  }, []);

  const fetchCustomer = async () => {
    try {
      let res = await services.getCustomers("BUYER");
      const rawData = res.data?.data || [];
      setCustomers(rawData);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };
  const filtered = customers.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.cars.some((car) => car.license.includes(search))
  );

  const handleSelect = (customer) => {
    navigate(`/customers/edit?customer_id=${customer.id}`);
  };

  const handleCreateClick = () => {
    navigate(`/customers/create`);
  };

  return (
    <div className="min-h-[calc(100vh-64px)] bg-gray-50 p-4 md:p-8">
      <AppBreadcrumbs />
      
      <div className="max-w-7xl mx-auto w-full">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-center my-6 gap-4">
          <h2 className="text-2xl font-bold text-gray-800">เลือกลูกค้า</h2>
          <button
            onClick={handleCreateClick}
            className="flex items-center gap-2 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-medium px-5 py-2.5 rounded-xl shadow-sm transition-all hover:shadow-md active:translate-y-0.5"
          >
            <AddIcon />
            <span>ลูกค้าใหม่</span>
          </button>
        </div>

        {/* Search */}
        <div className="relative mb-8 max-w-md">
           <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <SearchIcon className="text-gray-400" />
           </div>
           <input
              type="text"
              placeholder="ค้นหาชื่อลูกค้า หรือทะเบียนรถ"
              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-xl focus:ring-green-500 focus:border-green-500 block w-full pl-10 p-3 shadow-sm outline-none transition-all"
              value={search}
              onChange={(e) => setSearch(e.target.value.trimStart())}
           />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">
          {filtered.map((customer) => {
             const latestImg = customer.drivers?.length > 0 && customer.drivers[customer.drivers.length - 1]?.img 
                ? customer.drivers[customer.drivers.length - 1].img 
                : null;

             return (
                <div
                  key={customer.id}
                  onClick={() => handleSelect(customer)}
                  className="group bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-md hover:-translate-y-1 hover:border-emerald-300 flex flex-col h-full"
                >
                   <div className="flex h-full">
                       {/* Image Section */}
                       <div className="w-[140px] bg-gray-100 flex-shrink-0 relative overflow-hidden border-r border-gray-100">
                          {latestImg ? (
                             <img
                                src={latestImg}
                                alt={customer.name}
                                className="w-full h-full object-cover"
                             />
                          ) : (
                             <div className="w-full h-full flex items-center justify-center bg-gray-50 text-gray-300 p-2">
                                <ImageNotSupportedIcon style={{ fontSize: 48 }} />
                             </div>
                          )}
                       </div>

                       {/* Info Section */}
                       <div className="flex-1 p-5 flex flex-col min-w-0">
                          <h3 className="text-xl font-bold text-gray-800 line-clamp-1 mb-1.5" title={customer.name}>
                             {customer.name}
                          </h3>
                          
                          <div className="flex items-center gap-2 mb-4">
                             <span className={`text-xs px-2.5 py-0.5 rounded-full font-medium border ${
                                customer.personType === "normal" 
                                  ? "bg-green-50 text-green-700 border-green-100" 
                                  : "bg-blue-50 text-blue-700 border-blue-100"
                             }`}>
                                {customer.personType === "normal" ? "บุคคลธรรมดา" : "นิติบุคคล"}
                             </span>
                             {customer.group && (
                                <span className="text-xs px-2.5 py-0.5 rounded-full bg-gray-100 text-gray-600 border border-gray-200">
                                   กลุ่ม {customer.group}
                                </span>
                             )}
                          </div>

                          {/* Cars List */}
                          <div className="flex-1 overflow-y-auto max-h-[100px] pr-1 space-y-1.5 scrollbar-thin scrollbar-thumb-gray-200">
                             {customer.cars && customer.cars.length > 0 ? customer.cars.map((car) => (
                                <div key={car.id} className="flex items-center gap-2 text-sm text-gray-600">
                                   <LocalShippingIcon style={{ fontSize: 16 }} className="text-gray-400" />
                                   <span className="truncate">
                                      {car.license} <span className="text-gray-400 text-xs">({car.type})</span>
                                   </span>
                                </div>
                             )) : (
                                <div className="text-sm text-gray-300 italic">ไม่มีข้อมูลรถ</div>
                             )}
                          </div>
                       </div>
                   </div>
                </div>
             );
          })}
        </div>
      </div>
    </div>
  );
}
